module.exports = __webpack_public_path__ + "media/images/hrms/linkedin-circled-f2b780bab4e708c78b093c17cb5e3daa.svg";